const NEWSLETTER_FORM_ID = 'frm-newsletterForm-form';
document.addEventListener('DOMContentLoaded', () => {
    if (window.location.hash === '#' + NEWSLETTER_FORM_ID) {
        document.getElementById(NEWSLETTER_FORM_ID).scrollIntoView(false);
    }
});
